import React from 'react';
import { TextField, Stack, IconButton, InputAdornment } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  fullWidth?: boolean;
}

/**
 * Reusable search bar component for contract grids
 */
export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  fullWidth = true,
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <SearchIcon sx={{ color: '#64748b' }} />
      <TextField
        fullWidth={fullWidth}
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        InputProps={{
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onClear} sx={{ p: 0 }}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            '& fieldset': {
              borderColor: '#e2e8f0',
            },
            '&:hover fieldset': {
              borderColor: '#3b82f6',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#3b82f6',
            },
          },
        }}
      />
    </Stack>
  );
};

export default SearchBar;
